import React, {Component} from 'react';
import StripeCheckout from "react-stripe-checkout";
import {connect} from "react-redux";
import * as actions from './../store/actions';

class Payments extends Component {
    render() {
        const {handleToken} = this.props;

        return (
            <StripeCheckout
                name="Emailie"
                description="$5 for 5 credits"
                amount={500}
                token={token => handleToken(token)}
                stripeKey={process.env.REACT_APP_STRIPE_KEY}>
                <button className="btn pulse">Add credits</button>
            </StripeCheckout>
        );
    }
}

export default connect(null, actions)(Payments);